// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ReportPageTemplate_wrapper__1L2dY","switchWrapper":"ReportPageTemplate_switchWrapper__yfnmn","switchLabel":"ReportPageTemplate_switchLabel__1NJl_"};